export default {
  LOAD_EVENT_FORM_PAGE_START: 'LoadGeneralCompetencyEventFormPageStart',
  LOAD_EVENT_FORM_PAGE_END: 'LoadGeneralCompetencyEventFormPageEnd'
};
